/**
 * Embed Keys Module Routes
 *
 * Route definitions for the Embed Keys module.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/embed-keys',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.embed_keys',
        },
        children: [
            {
                path: '',
                name: 'embed-keys-list',
                component: () => import('./views/EmbedKeyList.vue'),
                meta: {
                    title: 'Embed Keys',
                },
            },
            {
                path: 'create',
                name: 'embed-keys-create',
                component: () => import('./views/EmbedKeyCreate.vue'),
                meta: {
                    title: 'Create Embed Key',
                },
            },
            {
                path: ':id',
                name: 'embed-keys-detail',
                component: () => import('./views/EmbedKeyDetail.vue'),
                meta: {
                    title: 'Embed Key Detail',
                },
            },
        ],
    },
]

export default routes
